import colors from './imports/Colors';
import icons from './imports/Icons';
import spacing from './imports/Spacing';
import { mq } from './imports/MediaQueries';
import * as mixins from './imports/Mixins.styles';
import * as typography from './imports/Typography.styles';
export const theme = {
    colors: colors,
    icons: icons,
    spacing: spacing,
    mixins: mixins,
    mq: mq,
    typography: typography,
};
